import { atom } from "recoil";

export const updateRfidDrawerState = atom({
  key: "updateRfidDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
